import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.#load();
  }

  /**
   * Reads product IDs from localStorage, fetches the section HTML server-side
   * via a search query, then injects the rendered cards into the DOM.
   */
  async #load() {
    const { sectionId, maxProducts } = this.dataset;

    const ids = RecentlyViewed.getProducts();

    if (!ids.length) {
      this.#hide();
      return;
    }

    const limit = Number(maxProducts) || 4;
    const slicedIds = ids.slice(0, limit);

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', slicedIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', String(limit));
    url.searchParams.set('section_id', sectionId);

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);

      if (!html) {
        this.#hide();
        return;
      }

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector(`recently-viewed-products[id="${this.id}"]`);

      if (!incoming?.innerHTML?.trim()) {
        this.#hide();
        return;
      }

      this.innerHTML = incoming.innerHTML;
    } catch (error) {
      console.error('recently-viewed-products:', error);
      this.#hide();
    }
  }

  #hide() {
    this.dataset.error = 'No recently viewed products to display';
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}